<template>
  <div class="xcard">
    <h3 class="text-center">Crear plantilla de contratos</h3>
    <hr />

    <v-combobox v-model="tipo" :items="tipos" label="Categoria de contrato" hide-details outlined dense></v-combobox>

    <div v-if="tipo.id == 1"><TCD /></div>
    <div v-else-if="tipo.id == 2"><TCE /></div>
    <div v-else-if="tipo.id == 3"><TCM /></div>
  </div>
</template>

<script>
  import TCD from '@/components/ATemplateContratoDiplo.vue';
  import TCE from '@/components/ATemplateContratoEsp.vue';
  import TCM from '@/components/ATemplateContratoMaes.vue';
  export default {
    data() {
      return {
        tipo: {},
        tipos: [
          { id: 1, text: 'Diplomados' },
          { id: 2, text: 'Especialidades' },
          { id: 3, text: 'Maestrias' },
        ],
      };
    },
    components: { TCD, TCE, TCM },
    watch: {},
    methods: {},
    mounted() {
      this.tipo = this.tipos[0];
    },
  };
</script>
